import { useCallback, useEffect, useState } from "react";

type FavoriteKind = "movie" | "novel";

const STORAGE_KEYS: Record<FavoriteKind, string> = {
  movie: "17c_fav_movies",
  novel: "17c_fav_novels",
};

function readList(kind: FavoriteKind): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS[kind]);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map((x) => String(x)) : [];
  } catch {
    return [];
  }
}

function writeList(kind: FavoriteKind, list: string[]) {
  try {
    localStorage.setItem(STORAGE_KEYS[kind], JSON.stringify(list));
  } catch {
    // ignore storage errors
  }
}

export function useFavorites(kind: FavoriteKind) {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    setIds(readList(kind));
  }, [kind]);

  const isFavorite = useCallback(
    (id: string) => ids.includes(id),
    [ids]
  );

  const toggle = useCallback(
    (id: string) => {
      setIds((prev) => {
        const next = prev.includes(id)
          ? prev.filter((x) => x !== id)
          : [...prev, id];
        writeList(kind, next);
        return next;
      });
    },
    [kind]
  );

  return { ids, isFavorite, toggle };
}